import { FC, useState } from 'react';

import { IconButton, InputAdornment, TextField } from '@mui/material';

import { ReactComponent as Visibility } from 'assets/icons/Visibility.svg';
import { ReactComponent as VisibilityHidden } from 'assets/icons/VisibilityHidden.svg';

import { FormField } from 'components/_basic/Form/FormField';

import { IPasswordTextInputProps } from './types';

export const PasswordTextInput: FC<IPasswordTextInputProps> = (props) => {
  const [isShowPassword, setIsShowPassword] = useState(false);

  const { id, label, value, fieldError, placeholder, maxLength = 16, ...restProps } = props;

  const handleClickShowPassword = () => {
    setIsShowPassword((isShowPassword) => !isShowPassword);
  };

  return (
    <FormField id={id} label={label} error={fieldError?.message}>
      <TextField
        {...restProps}
        value={value}
        placeholder={placeholder}
        type={!isShowPassword ? 'password' : 'text'}
        inputProps={{ maxLength: maxLength }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword}>
                {isShowPassword ? <VisibilityHidden /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </FormField>
  );
};
